import React, { FC } from 'react';
import styles from './Logo.module.scss';
import clsx from 'clsx';
import Link from 'next/link';

import LogoFullIcon from '@/assets/icons/logo_full.svg';
import { ROUTES } from '@/routes/constants';
import { Icon } from '@/components/atoms/Icon';

type Props = {
  size?: 'xs' | 's' | 'm' | 'l' | 'xl';
  full?: boolean;
};

const Logo: FC<Props> = ({ size = 'm', full }) => {
  return (
    <Link
      href={ROUTES.Index}
      className={clsx(styles.logo, styles[size], {
        [styles.full]: full,
      })}
    >
      {full ? (
        <LogoFullIcon />
      ) : (
        <Icon name="general/reprism-icon/24" color="var(--icon-primary)" className={styles.icon} />
      )}
    </Link>
  );
};

export { Logo };
